
import VueGtag from 'vue-gtag-next'
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(VueGtag, {
    deferScriptLoad: true,
    property: {
      id: 'G-R5LBD3N5K4'
    }
  })
})